import { useState } from "react";
import DatePicker from "react-datepicker";

export default function TimeRangePicker({ value, onChange }) {
  const [open, setOpen] = useState(false);

  const handleStart = (start) => {
    onChange({ ...value, start });
  };

  const handleEnd = (end) => {
    onChange({ ...value, end });
  };

  return (
    <div className="relative w-full">
      {/* DISPLAY FIELD (matches Figma) */}
      <div
        onClick={() => setOpen(!open)}
        className="
          h-11 w-full border border-[#E5E7EB] rounded-lg 
          px-3 flex items-center text-sm text-gray-700 
          cursor-pointer bg-white
        "
      >
        {value.start && value.end
          ? `${value.start.toLocaleTimeString([], {
              hour: "numeric",
              minute: "2-digit",
            })} - ${value.end.toLocaleTimeString([], {
              hour: "numeric",
              minute: "2-digit",
            })}`
          : "Select time range"}
      </div>

      {/* POPUP */}
      {open && (
        <div
          className="
            absolute mt-2 bg-white p-4 rounded-lg shadow-lg z-20
            border border-gray-200
          "
        >
          <div className="flex gap-4">
            <div>
              <div className="text-sm mb-1 text-gray-600">Start Time</div>
              <DatePicker
                selected={value.start}
                onChange={handleStart}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={30}
                dateFormat="h:mm aa"
                className="border border-gray-300 rounded-lg px-3 h-10 text-sm"
              />
            </div>

            <div>
              <div className="text-sm mb-1 text-gray-600">End Time</div>
              <DatePicker
                selected={value.end}
                onChange={handleEnd}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={30}
                dateFormat="h:mm aa"
                className="border border-gray-300 rounded-lg px-3 h-10 text-sm"
              />
            </div>
          </div>

          <button
            onClick={() => setOpen(false)}
            className="mt-3 text-sm text-[#00B8C8] font-semibold"
          >
            Done
          </button>
        </div>
      )}
    </div>
  );
}
